var map = {
	"./azure.png": 6926,
	"./certus.png": 6254,
	"./contactMailDark.svg": 3527,
	"./coursera.png": 2558,
	"./developerActivity.svg": 36,
	"./foto_cuadrada.png": 7511,
	"./googleAssistant.svg": 760,
	"./logounsch.png": 6817,
	"./manOnTable.svg": 8776,
	"./mongodb.png": 895,
	"./platzi.png": 6223,
	"./programmer.svg": 522,
	"./skill.svg": 1601,
	"./talksCardBack.svg": 2592,
	"./udemy.png": 6835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;